<div class="content content-fixed">
  <div class="container">
    <div class="text-xl mb-3 normal-case">VDD Onboarding</div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ successMessage }}
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700">
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ errorMessage }}
      </div>
    </div>

    <form
      class="w-full flex flex-wrap bg-white rounded-md shadow-lg p-4 flex-col"
      #form="ngForm"
      (ngSubmit)="onSubmit()"
      *ngIf="!successMessage"
    >
      <mat-form-field>
        <mat-label>Company Name</mat-label>
        <input
          matInput
          id="companyName"
          name="companyName"
          type="text"
          required
          [(ngModel)]="values.companyName"
          #companyName="ngModel"
          [disabled]="isLoading"
        />
        <mat-error *ngIf="companyName.errors?.required">Company Name is required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>EIN</mat-label>
        <input
          matInput
          id="ein"
          name="ein"
          type="text"
          required
          [(ngModel)]="values.ein"
          #ein="ngModel"
          [disabled]="isLoading"
        />
        <mat-error *ngIf="ein.errors?.required">EIN is required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Contact Name</mat-label>
        <input
          matInput
          id="contactName"
          name="contactName"
          type="text"
          required
          [(ngModel)]="values.contactName"
          #contactName="ngModel"
          [disabled]="isLoading"
        />
        <mat-error *ngIf="contactName.errors?.required">Contact Name is required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Contact Email</mat-label>
        <input
          matInput
          id="contactEmail"
          name="contactEmail"
          type="email"
          pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
          required
          [(ngModel)]="values.contactEmail"
          #contactEmail="ngModel"
          [disabled]="isLoading"
        />
        <mat-error *ngIf="contactEmail.errors?.required">Contact Email is required</mat-error>
        <mat-error *ngIf="contactEmail.errors?.pattern">Contact Email must be a valid email address</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Contact Phone</mat-label>
        <input
          matInput
          id="contactPhone"
          name="contactPhone"
          type="tel"
          pattern="^\+?[0-9\s\-\(\)]{7,20}$"
          required
          [(ngModel)]="values.contactPhone"
          #contactPhone="ngModel"
          [disabled]="isLoading"
        />
        <mat-error *ngIf="contactPhone.errors?.required">Contact Phone is required</mat-error>
        <mat-error *ngIf="contactPhone.errors?.pattern">Invalid phone number</mat-error>
      </mat-form-field>
      @if (orgCode === 'PAVILION') {
      <mat-form-field>
        <mat-label>Type of property</mat-label>
        <mat-select name="propertyType" [(ngModel)]="values.propertyType" #propertyType="ngModel" required>
          @for (propertyType of propertyTypeOptions; track propertyType) {
          <mat-option [value]="propertyType.value">{{ propertyType.label }}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="propertyType.errors?.required">Type of property is required</mat-error>
      </mat-form-field>
      } @else {
      <div class="flex flex-col gap-2">
        <label class="text-sm font-medium text-gray-700">Package Type*</label>
        <mat-radio-group name="packageType" [(ngModel)]="values.packageType" [disabled]="isLoading" class="flex gap-4">
          @for (option of packageOptions; track option.value) {
          <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
      }
      <button mat-fab extended type="submit" [disabled]="isLoading || !form.valid">
        @if (isLoading) {
        <mat-icon><mat-spinner diameter="20"> </mat-spinner></mat-icon>
        }
        <mat-icon fontIcon="send"></mat-icon>
        Send to Vendor
      </button>
    </form>
  </div>
</div>
